// @flow
export type EnvironmentType = "production" | "staging" | "development" | "test" | "local";

export interface FirebaseEnv {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface GoogleEnv {
  clientId: string;
}

let appEnv: EnvironmentType;

if (
    process.env.APP_ENV === "production" ||
    process.env.APP_ENV === "staging" ||
    process.env.APP_ENV === "development" ||
    process.env.APP_ENV === "test" ||
    process.env.APP_ENV === "local"
) {
  appEnv = process.env.APP_ENV;
} else {
  throw new Error("APP_ENV is not defined");
}

class ConfigService {
  // static instance = new ConfigService(appEnv);

  apiEndpoint: string;
  newApiEndpoint: string;
  firebaseEnv: FirebaseEnv;
  googleEnv: GoogleEnv;
  googleanalyticsid: string;
  paypalPlatformPublishKey: string;
  paypalPublishKey: string;
  stripeKey: string;
  ogImageUrl: string;
  countryApi: string;
  experienceInquiry: string;

  cellars: string;
  cellarExperiences: string;
  cellarProducts: string;
  cellar: string;
  cellarReservation: string;
  coupon: string;
  experiences: string;
  newexperiences: string;
  experienceProducts: string;
  experienceAvailabilities: string;
  experienceAvailability: string;
  hostReservation: string;
  hostReservationId: string;
  guestReservationId: string;
  noGuestReservationId: string;
  products: string;
  profile: string;
  authService: string;
  profileReservation: string;
  noProfileReservation: string;
  profileGifts: string;
  noProfileGifts: string;
  payments: string;
  utilities: string;
  regions: string;
  search: string;
  contactMessages: string;
  env: EnvironmentType;

  constructor(env: EnvironmentType) {
    this.env = env;
    switch (env) {
      case "production":
        this.apiEndpoint = "https://api.divinea.com/api/v1";
        this.newApiEndpoint = "https://api.divinea.com/api/v2";
        this.googleanalyticsid = "UA-129093007-1";
        this.firebaseEnv = {
          apiKey: "AIzaSyC5IvS6rfgo6jEM_Y9Fyrawtxb72cf7Nhg",
          authDomain: "divinea-production.firebaseapp.com",
          databaseURL: "",
          projectId: "divinea-production",
          storageBucket: "",
          messagingSenderId: "",
          appId: ""
        };
        this.googleEnv = {
          clientId: "209822336933-bkpmohqfqofpd8cq4a9a3lv4bfv80g2t.apps.googleusercontent.com"
        };
        this.stripeKey = "pk_live_otXOyDAbyltQA4gRh1uqWsuC005ZBr71xY";
        this.ogImageUrl = "https://res.cloudinary.com/divinea/image/upload/c_scale,h_600/v1581436157/production/assets/Toblino_Degustazione_il_piccolo_menu.jpg";
        this.paypalPlatformPublishKey = "AfeO3vfcEp-hzMHo6RFhPFVveAdFJ2fgcB3pTot94SUhtDEqAULkFFHnODw3lzWFGXBQ0yxrbwwk9gK_";
        this.paypalPublishKey = "AftmIcz-1bLQDnNGBzD074o5aoeWN_uYbWdVztCd4-MCqVw37KWsvRZYvaPmXFpgRq4Cm6Mx2-2fgk-T"
        break;
      case "staging":
        this.apiEndpoint = "https://api-staging.divinea.com/api/v1";
        this.newApiEndpoint = "https://api-staging.divinea.com/api/v2";
        //this.apiEndpoint = "https://api-dev.divinea.com/api/v1";
        //this.newApiEndpoint = "https://api-dev.divinea.com/api/v2";
        // this.apiEndpoint = "https://api.divinea.com/api/v1";
        // this.newApiEndpoint = "https://api.divinea.com/api/v2";
        this.googleanalyticsid = "ua-xxxxxxxxx-x";
        this.ogImageUrl = "https://res.cloudinary.com/divinea/image/upload/c_scale,h_600/v1581435967/staging/assets/Toblino_Degustazione_il_piccolo_menu.jpg";
        this.firebaseEnv = {
          apiKey: "AIzaSyACcwQdnV7Bh3B3Y7qh7m1CrlGQTLnBJ00",
          authDomain: "still-summit-235616.firebaseapp.com",
          databaseURL: "https://still-summit-235616.firebaseio.com",
          projectId: "still-summit-235616",
          storageBucket: "still-summit-235616.appspot.com",
          messagingSenderId: "77597896257",
          appId: ""
        };
        this.googleEnv = {
          clientId: "77597896257-b6t617j6k66r32d3356oeiomcnnksdbc.apps.googleusercontent.com"
        };
        this.stripeKey = "pk_test_51RMP0CPu4DL4LUPyZjhR0V3W6Fer6XpM0gRwA5EmCIAQHpIi9dxNdHganXPPsXKMAcyznpnTSALM4QIypObuoror00mznRksD3";
        this.paypalPlatformPublishKey = "AV-BU1TwU1WKE6FQuSpMeF4NhpNFB1Z8gSM5vctE2tIGjQo_NgO_622idz0HvcZwCtGBkZw8lspcJ9DZ";
        this.paypalPublishKey = "AeU6Ro6siGMclVY6LUQEH7F3suWgYmehE61NIxNYP_gUERRgYhmmE6fkfRL_vlpp62C9skQHyE62PmKW"
        break;
      case "test":
        this.apiEndpoint = "https://api-test.divinea.com/api/v1";
        this.newApiEndpoint = "https://api-test.divinea.com/api/v2";
        this.googleanalyticsid = "ua-xxxxxxxxx-x";
        this.ogImageUrl = "https://res.cloudinary.com/divinea/image/upload/c_scale,h_600/v1581435967/staging/assets/Toblino_Degustazione_il_piccolo_menu.jpg";
        this.firebaseEnv = {
          apiKey: "AIzaSyACcwQdnV7Bh3B3Y7qh7m1CrlGQTLnBJ00",
          authDomain: "still-summit-235616.firebaseapp.com",
          databaseURL: "https://still-summit-235616.firebaseio.com",
          projectId: "still-summit-235616",
          storageBucket: "still-summit-235616.appspot.com",
          messagingSenderId: "77597896257",
          appId: ""
        };
        this.googleEnv = {
          clientId: "77597896257-b6t617j6k66r32d3356oeiomcnnksdbc.apps.googleusercontent.com"
        };
        this.stripeKey = "pk_test_51RX174Pr0hnuxgRS5Es0FvSclZEnZtGifDL0LTGlHU4QnJ5ASjhqtThXT9qtpo7TR1JaETTajlKCURgl5lW3KaN600KyvG3sDc";
        this.paypalPublishKey = "AeU6Ro6siGMclVY6LUQEH7F3suWgYmehE61NIxNYP_gUERRgYhmmE6fkfRL_vlpp62C9skQHyE62PmKW";
        this.paypalPlatformPublishKey = "AV-BU1TwU1WKE6FQuSpMeF4NhpNFB1Z8gSM5vctE2tIGjQo_NgO_622idz0HvcZwCtGBkZw8lspcJ9DZ";

        break;
      case "development":
        this.apiEndpoint = "https://api-dev.divinea.com/api/v1";
        this.newApiEndpoint = "https://api-dev.divinea.com/api/v2";
        this.googleanalyticsid = "ua-xxxxxxxxx-x";
        this.ogImageUrl = "https://res.cloudinary.com/divinea/image/upload/c_scale,h_600/v1581435967/staging/assets/Toblino_Degustazione_il_piccolo_menu.jpg";
        this.firebaseEnv = {
          apiKey: "AIzaSyACcwQdnV7Bh3B3Y7qh7m1CrlGQTLnBJ00",
          authDomain: "still-summit-235616.firebaseapp.com",
          databaseURL: "https://still-summit-235616.firebaseio.com",
          projectId: "still-summit-235616",
          storageBucket: "still-summit-235616.appspot.com",
          messagingSenderId: "77597896257",
          appId: ""
        };
        this.googleEnv = {
          clientId: "77597896257-b6t617j6k66r32d3356oeiomcnnksdbc.apps.googleusercontent.com"
        };
        this.stripeKey = "pk_test_51RIuW1Po3PKbAEtgHbjdSRo92Of7Hw1mrf5x2leTm69Y0YSyCaV82f1FGB2zu3T1iWwrqrfI2N7SpMQXvLA5oBz500gZvvHWx1";
        this.paypalPlatformPublishKey = "AeU6Ro6siGMclVY6LUQEH7F3suWgYmehE61NIxNYP_gUERRgYhmmE6fkfRL_vlpp62C9skQHyE62PmKW";
        this.paypalPublishKey = "AV-BU1TwU1WKE6FQuSpMeF4NhpNFB1Z8gSM5vctE2tIGjQo_NgO_622idz0HvcZwCtGBkZw8lspcJ9DZ";

        break;
      case "local":
        this.apiEndpoint = "http://localhost:3000/api/v1";
        this.newApiEndpoint = "http://localhost:3000/api/v2";
        this.googleanalyticsid = "UA-xxxxxxxxx-1";
        this.firebaseEnv =  {
          apiKey: "AIzaSyACcwQdnV7Bh3B3Y7qh7m1CrlGQTLnBJ00",
          authDomain: "still-summit-235616.firebaseapp.com",
          databaseURL: "https://still-summit-235616.firebaseio.com",
          projectId: "still-summit-235616",
          storageBucket: "still-summit-235616.appspot.com",
          messagingSenderId: "77597896257",
          appId: ""
        };
        this.googleEnv = {
          clientId: "77597896257-b6t617j6k66r32d3356oeiomcnnksdbc.apps.googleusercontent.com"
        };
        this.stripeKey = "pk_test_72oeYDBeQR48ufUCSAmfLjVl005qHhCHd6";
        this.ogImageUrl = "https://res.cloudinary.com/divinea/image/upload/c_scale,h_600/v1581436157/production/assets/Toblino_Degustazione_il_piccolo_menu.jpg";
        this.paypalPlatformPublishKey = "AV-BU1TwU1WKE6FQuSpMeF4NhpNFB1Z8gSM5vctE2tIGjQo_NgO_622idz0HvcZwCtGBkZw8lspcJ9DZ";
        this.paypalPublishKey = "AeU6Ro6siGMclVY6LUQEH7F3suWgYmehE61NIxNYP_gUERRgYhmmE6fkfRL_vlpp62C9skQHyE62PmKW"
        break;
      default:
        this.apiEndpoint = "http://192.168.0.113:3000/api/v1";
        this.newApiEndpoint = "http://192.168.0.113:3000/api/v2";
        this.googleanalyticsid = "ua-xxxxxxxxx-x";
        this.ogImageUrl = "https://res.cloudinary.com/divinea/image/upload/c_scale,h_600/v1581435967/staging/assets/Toblino_Degustazione_il_piccolo_menu.jpg";
        this.firebaseEnv = {
          apiKey: "AIzaSyARJ1yZxvSmkvwzNbXLUH2np6pBIH1l2Rg",
          authDomain: "divinea-development.firebaseapp.com",
          databaseURL: "https://divinea-development.firebaseio.com",
          projectId: "divinea-development",
          storageBucket: "divinea-development.appspot.com",
          messagingSenderId: "384307232095",
          appId: ""
        };
        this.googleEnv = {
          clientId: "77597896257-b6t617j6k66r32d3356oeiomcnnksdbc.apps.googleusercontent.com"
        };
        this.stripeKey = "pk_test_72oeYDBeQR48ufUCSAmfLjVl005qHhCHd6";
        this.paypalPlatformPublishKey = "AV-BU1TwU1WKE6FQuSpMeF4NhpNFB1Z8gSM5vctE2tIGjQo_NgO_622idz0HvcZwCtGBkZw8lspcJ9DZ";
        this.paypalPublishKey = "AeU6Ro6siGMclVY6LUQEH7F3suWgYmehE61NIxNYP_gUERRgYhmmE6fkfRL_vlpp62C9skQHyE62PmKW";
        break;
    }
    // export default instance = new ConfigService(appEnv);
    // Assign new API here
    this.cellars = `${this.apiEndpoint}/companies`;
    this.cellarProducts = `${this.apiEndpoint}/companies/:CellarId/products`;
    this.cellarExperiences = `${this.apiEndpoint}/companies/:CellarId/experiences`;
    this.cellar = `${this.apiEndpoint}/company`;
    this.cellarReservation = `${this.apiEndpoint}/host/reservations`;
    this.coupon = `${this.apiEndpoint}/coupons`;
    this.experiences = `${this.apiEndpoint}/experiences`;
    this.newexperiences = `${this.newApiEndpoint}/experiences`;
    this.experienceAvailabilities = `${this.newApiEndpoint}/experiences/:ExperienceId/availabilities`;
    this.experienceAvailability = `${this.newApiEndpoint}/experiences/:ExperienceId/availability`;
    this.experienceProducts = `${this.apiEndpoint}/experiences/:ExperienceId/products`;
    this.hostReservation = `${this.apiEndpoint}/host/reservations`;
    this.hostReservationId = `${this.apiEndpoint}/host/reservations/:reservationId`;
    this.guestReservationId = `${this.apiEndpoint}/guest/reservations/:reservationId`;
    this.noGuestReservationId = `${this.apiEndpoint}/reservations/:reservationId`;
    this.products = `${this.apiEndpoint}/products`;
    this.profile = `${this.newApiEndpoint}/profile`;
    this.authService = `${this.newApiEndpoint}`;
    this.profileReservation = `${this.apiEndpoint}/guest/reservations`;
    this.noProfileReservation = `${this.apiEndpoint}/reservations`;
    this.profileGifts = `${this.apiEndpoint}/guest/gifts`;
    this.noProfileGifts = `${this.apiEndpoint}/gifts`;
    this.payments = `${this.apiEndpoint}/payments`;
    this.utilities = `${this.apiEndpoint}/utilities`;
    this.regions = `${this.newApiEndpoint}/regions`;
    this.search = `${this.newApiEndpoint}/search`;
    this.contactMessages = `${this.newApiEndpoint}/contact_messages`;
    this.countryApi = 'https://divinea.com/countries/v2/all';
    this.experienceInquiry = `${this.newApiEndpoint}/experience-inquiry`;
  }
}

export const configService = new ConfigService(appEnv);
